import { render, staticRenderFns } from "./customer-select-item.vue?vue&type=template&id=1a72a989&scoped=true&"
import script from "./customer-select-item.vue?vue&type=script&lang=js&"
export * from "./customer-select-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a72a989",
  null
  
)

export default component.exports